import { type OptionsFetchQueryResult, OptionsType } from '@openx/types/options.ts';
import type { UseQueryOptions } from '@openx/types/reactQuery.ts';
import { useTranslation } from 'react-i18next';

import { useOptionsFetch } from './generics/useOptionsFetch.tsx';

export function useDeviceOptionsFetch(queryOptions?: UseQueryOptions<OptionsFetchQueryResult>) {
  const { t } = useTranslation();
  const {
    isLoading: isDeviceOptionsLoading,
    data: deviceOptions,
    refetch: refetchDeviceOptions,
  } = useOptionsFetch({
    errorMessage: t('Failed to fetch Device options'),
    optionType: OptionsType.DEVICE,
    queryOptions,
  });

  return {
    deviceOptions,
    isDeviceOptionsLoading,
    refetchDeviceOptions,
  };
}
